/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AtsCandidateIdentity } from './atsCandidateIdentity';
import type { CandidateMatch } from './candidateMatch';

export interface NeedsMergeItem {
  link_id: string;
  remote_id: string;
  entity_type: string;
  reason: string | null;
  ats_candidate: AtsCandidateIdentity;
  candidates?: CandidateMatch[];
}
